import {
  type UnknownAction,
  combineSlices,
  configureStore,
  Tuple,
  Action,
} from '@reduxjs/toolkit';
import { default as createSagaMiddleware } from 'redux-saga';
import { ConsoleLogger } from '@team/logger';
import { SagaManager } from '@team/saga-kit';
import { createContext } from 'react';
import {
  type ReactReduxContextValue,
  createDispatchHook,
  createSelectorHook,
  createStoreHook,
} from 'react-redux';
import { enableMapSet } from 'immer';

const sagaMiddleware = createSagaMiddleware();

const subscribers = new Set<(action: Action) => void>();

export const subscribeToActions = (
  callback: (action: Action) => void
): (() => void) => {
  subscribers.add(callback);
  return () => subscribers.delete(callback);
};

const sagaLogger = new ConsoleLogger('SagaManager');
export const sagaManager = new SagaManager(sagaMiddleware, sagaLogger);

export const rootReducer = combineSlices();

/**
 * Позволяет работать с неизменяемым состоянием
 * Упрощает работу с Map Set в redux
 */
enableMapSet();

export const store = configureStore<
  AppState,
  UnknownAction,
  Tuple<[typeof sagaMiddleware]>
>({
  reducer: rootReducer,
  middleware: () => new Tuple(sagaMiddleware),
});

export const context = createContext<Nullable<ReactReduxContextValue>>(null);

export const useDispatch = createDispatchHook<AppState>(context);
export const useSelector = createSelectorHook(context);
export const useStore = createStoreHook<AppState>(context);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AppState = any;
